import { render, staticRenderFns } from "./ProjectDetails.vue?vue&type=template&id=f343878c&scoped=true"
import script from "./ProjectDetails.vue?vue&type=script&lang=js"
export * from "./ProjectDetails.vue?vue&type=script&lang=js"
import style0 from "./ProjectDetails.vue?vue&type=style&index=0&id=f343878c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f343878c",
  null
  
)

export default component.exports